import type { TrackingObject } from './types/TagManager';

export default class NBA {
  private vm: string;

  constructor(vm: string) {
    this.vm = vm;
  }

  get(event: string): TrackingObject | null {
    let trackingObject: TrackingObject | null = null;
    const trackEvent = 'track-event';
    const eventCategory = 'NBA Min side';
    const eventLabel = `NBA ${this.vm}`;

    switch (event) {
      case 'nba-load': {
        trackingObject = {
          event: trackEvent,
          eventCategory,
          eventAction: 'impression',
          eventLabel,
          eventValue: '0',
          eventNoninteraction: true,
          data: null
        };
        break;
      }
      case 'nba-cta-click': {
        trackingObject = {
          event: trackEvent,
          eventCategory,
          eventAction: 'CTA click',
          eventLabel,
          eventValue: '0',
          eventNoninteraction: true,
          data: null
        };
        break;
      }
    }

    return trackingObject;
  }
}
